import React from 'react';
import Hidden from '@material-ui/core/Hidden';
import Nav from '../components/OldNav';
import Footer from '../components/OldFooter';
import NoticeBanner from '../components/notice-banner';

const PlainLayout = ({ 
  children,
  currUser,
  isAuthenticated,
  handleLogout,
  history,
  classes,
  noticeBanner,
  ...props
 }) => {
  return (
    <React.Fragment>
      <Hidden mdUp>
        <Nav
          currUser={currUser}
          isAuthenticated={isAuthenticated}
          handleLogout={handleLogout}
          history={history}
          {...props}
        />
      </Hidden>
      <NoticeBanner
        message={noticeBanner && noticeBanner.message}
        messageFr={noticeBanner && noticeBanner.messageFr}
        visible={noticeBanner && noticeBanner.enabled}
        style={{ position: "static" }}
      />
      {children}
      <Hidden mdUp>
        <Footer />
      </Hidden>
    </React.Fragment>
  );
};

export default PlainLayout;
